module.exports = __webpack_public_path__ + "icomoon.876f06ef96f6587f2fca.svg";


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/assets/fonts/icomoon.svg?aa6i4s
// module id = ../../../../../src/assets/fonts/icomoon.svg?aa6i4s
// module chunks = 11